import { TNotification } from '@/types/notifications';
import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

export type TUsersState = {
    list: TNotification[]
}

const initialState: TUsersState = {
    list: [],
};

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        addNotificationDanger: (state, action: PayloadAction<Omit<TNotification, 'variant'>>) => {
            state.list.push({
                ...action.payload,
                variant: 'danger',
                timer: action.payload.timer || 3000,
                id: nanoid(),
            });
        },
        removeNotification: (state, action: PayloadAction<string>) => {
            state.list = state.list.filter(item => item.id !== action.payload);
        },
    },
});

export const { addNotificationDanger, removeNotification } = notificationSlice.actions;
